import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-inner-page-template',
  templateUrl: './inner-page-template.component.html',
  styleUrls: ['./inner-page-template.component.scss']
})
export class InnerPageTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
